import React, { useState, useEffect } from 'react';
import { noop } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useAuth, SpinGlobal } from '@monument/core';
import { useOnboarding } from '@services/onboarding';
import { useMembership } from '@services/membership/context';
import { useInsurance } from '@services/insurance';
import {
  processQueryParams,
  useInterceptInvalidOnboardingNavigation,
  validatePageLoadOnboardingRules,
} from './utils';

// Before routing, fetch core user data every page needs + execute any redirect business logic
const InitializeAuthenticatedPage = ({ children }) => {
  const history = useHistory();
  const [initializing, setInitializing] = useState(true);
  const { onboardingReq, transition } = useOnboarding();
  const { submission, cards } = useInsurance();
  const membershipReq = useMembership();
  const invalidNavigationPending = useInterceptInvalidOnboardingNavigation();

  const initialize = async () => {
    // https://github.com/alibaba/hooks/issues/812
    const [onboarding] = await Promise.all([
      onboardingReq.runAsync().catch(noop),
      submission.flow.runAsync(),
      cards.runAsync(),
    ]);

    processQueryParams({ history });

    validatePageLoadOnboardingRules({
      history,
      onboarding,
      transition,
    });

    await membershipReq.run();

    setInitializing(false);
  };

  useEffect(() => {
    initialize();
  }, []);

  if (initializing || invalidNavigationPending) {
    return <SpinGlobal />;
  }

  return children;
};

const InitializePage = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? (
    <InitializeAuthenticatedPage>{children}</InitializeAuthenticatedPage>
  ) : (
    children
  );
};

export default InitializePage;
